import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditSupportType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        supportType: this.props.ItemList ? this.props.ItemList.supportType : null,
        disc: this.props.ItemList ? this.props.ItemList.disc : null,

        id: this.props.ItemList ? this.props.ItemList.id : null,
      },
    };
  }
  onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "supportType") {
      this.setState({
        value: { ...this.state.value, supportType: value },
      });
    } else if (name === "disc") {
      this.setState({
        value: { ...this.state.value, disc: value },
      });
    }
  };
  submit = () => {
    let data = this.state.value;

    if (data.supportType !== "" && data.disc !== "") {
      this.props.EditSupportType(this.state.value);

      this.props.closeEditModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        supportType: nextProps.ItemList && nextProps.ItemList.supportType,
        disc: nextProps.ItemList && nextProps.ItemList.disc,

        id: nextProps.ItemList && nextProps.ItemList.id,
      },
    });
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.showsupportTypeEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Support Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="supportType">
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="supportType"
                            onChange={this.onChange}
                            value={this.state.value.supportType}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="disc">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="disc"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.disc}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditSupportType;
